import type { FC, ReactNode } from 'react';
import { CreditLimit, SceneWrapper, SectionTitle } from '~/components';
import { currencyParser } from '~/modules';
import { ButtonComponent, FooterWrapper } from './styles';
type CreditSimulationSummaryProps = {
  onSimulate: () => void;
  onSimulateAgain: () => void;
  items: Record<string, string>;
};

const CreditSimulationSummary: FC<CreditSimulationSummaryProps> = ({
  items,
  onSimulate,
  onSimulateAgain,
}) => {
  const footer: ReactNode = (
    <FooterWrapper>
      <ButtonComponent
        id="btn-simulation-summary"
        onPress={onSimulateAgain}
        transparent
        fullWidth
      >
        SIMULAR NOVAMENTE
      </ButtonComponent>
      <ButtonComponent
        id="btn-simulation-summary"
        onPress={onSimulate}
        fullWidth
      >
        SOLICITAR CRÉDITO
      </ButtonComponent>
    </FooterWrapper>
  );
  return (
    <SceneWrapper footer={footer}>
      <SectionTitle>Essa é a parcela ideal para você?</SectionTitle>
      <CreditLimit
        title="Valor solicitado"
        value={currencyParser('1000')}
        details={items}
      />
    </SceneWrapper>
  );
};

export default CreditSimulationSummary;
